export const StudentsData = [
    {
      id: 1,
      name:"Usuario de prueba",
      email: 'prueba@hotmail.com',
      password: '123',
      courses: [1], // IDs de cursos permitidos
      paymentStatus: {
        1: "half"  // o "full"
      }
    },
    {
      id: 2,
      name:"Maria Jose Lopez",
      email: 'maria@hotmail.com',
      password: 'abcdef',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 3,
      name:"Alejandro Sierra Toro",
      email: 'asierrat2014@gmail.com',
      password: 'dissempacademy3',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 4,
      name:"Juan Gonzalez",
      email: 'gabriel4354@gmail.com',
      password: 'dissempacademy4',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 5,
      name:"Reinaldo Jose Batipta Febres",
      email: 'reinaldobatipta2016@gmail.com',
      password: 'dissempacademy5',
      courses: [1],
      paymentStatus: {
        1: "half" 
      }
    },
    {
      id: 6,
      name:"Jesús Alexis Avendaño",
      email: 'juandejesusav01@gmail.com',
      password: 'dissempacademy6',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 7,
      name:"Carlos De Sousa",
      email: 'carlitosdesousa6@gmail.com',
      password: 'dissempacademy7',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 8,
      name:"Leonardo Cuba Arias",
      email: 'leonardocubarias@gmail.com',
      password: 'dissempacademy8',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 9,
      name:"José Sanchez",
      email: 'sanchezveldu@gmail.com',
      password: 'dissempacademy9',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 9,
      name:"Renier Guerrero",
      email: 'renier.guerrero23@gmail.com',
      password: 'dissempacademy11',
      courses: [1],
      paymentStatus: {
        1: "half"
      }
    },
    {
      id: 10,
      name:"Sebastian Valencia",
      email: 'sebastianvp55@gmail.com',
      password: 'dissempacademy0123',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 11,
      name:"Ronnield Rodriguez",
      email: 'alexanroxa@gmail.com',
      password: 'dissempacademy0124',
      courses: [1],
      paymentStatus: {
        1: "half"
      }
    },
    {
      id: 12,
      name:"Isaac Chirino",
      email: 'david.chirino2005@gmail.com',
      password: 'dissempacademy0125',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 13,
      name:"Luis Daniel Sojo",
      email: 'luis.aref1988@gmail.com',
      password: 'dissempacademy0126',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 14,
      name:"Fernando Betancourt",
      email: 'ferbetorfabi@gmail.com',
      password: 'dissempacademy0127',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 15,
      name:"Oscar Laya",
      email: 'oscarlaya@gmail.com',
      password: 'dissempacademy0128',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 16,
      name:"Jose Cordova",
      email: 'nesspsi789@gmail.com',
      password: 'dissempacademy0129',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 17,
      name:"José Torres",
      email: 'jt8349517@gmail.com',
      password: 'dissempacademy0130',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 18,
      name:"Mailine Valentina Meneses",
      email: 'mailinemenese4@gmail.com',
      password: 'dissempacademy0131',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 19,
      name:"Williams Suarez",
      email: 'wesuarezbermudez@gmail.com',
      password: 'dissempacademy0132',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 20,
      name:"Darianny Betania Marin",
      email: 'marinndarianny@gmail.com',
      password: 'dissempacademy0133',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 21,
      name:"Marlos Gómez",
      email: 'g_marlos@hotmail.com',
      password: 'dissempacademy0134',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 22,
      name:"German Guedez",
      email: 'gdguedez@gmail.com',
      password: 'dissempacademy0135',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 23,
      name:"Fernando Ruiz",
      email: 'rahfernandoruiz@gmail.com',
      password: 'dissempacademy0136',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 24,
      name: "Fabian Villarreal",
      email: 'fabianvillareal204@gmail.com',
      password: 'dissempacademy0137',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 25,
      name: "Rosa Karolina Chacon",
      email: 'rosakachacon12@gmail.com',
      password: 'dissempacademy0138',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 26,
      name: "Mariah Gutierrez",
      email: 'mariahgga26@gmail.com',
      password: 'dissempacademy0139',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 27,
      name: "Victor Jose Mendoza",
      email: 'victormendozah@gmail.com',
      password: 'dissempacademy0140',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 28,
      name: "Luis Eduardo Bello",
      email: 'bellomelian@gmail.com',
      password: 'dissempacademy0141',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
    {
      id: 29,
      name: "Edduin Rodriguez",
      email: 'edduinrr@gmail.com',
      password: 'dissempacademy8539*',
      courses: [1],
      paymentStatus: {
        1: "full"
      }
    },
  ];
  
  export default StudentsData;
